import { useContext } from 'react';
import { StoreContext } from '../contexts/StoreContext';

export const useStore = () => {
  const ctx = useContext(StoreContext);
  if (!ctx) throw new Error('useStore deve ser usado dentro de StoreProvider');
  return ctx;
};

export default useStore;
